module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.5370741482966,
						"dataLabels": {
							"enabled": true,
							"format": "342",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.31663326653307,
						"dataLabels": {
							"enabled": true,
							"format": "291",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.10821643286573,
						"dataLabels": {
							"enabled": true,
							"format": "270",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 44.68937875751503,
						"dataLabels": {
							"enabled": true,
							"format": "223",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 37.27454909819639,
						"dataLabels": {
							"enabled": true,
							"format": "186",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 91.93916349809886,
						"dataLabels": {
							"enabled": true,
							"format": "1209",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.6425855513308,
						"dataLabels": {
							"enabled": true,
							"format": "1021",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.00380228136882,
						"dataLabels": {
							"enabled": true,
							"format": "960",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.57414448669202,
						"dataLabels": {
							"enabled": true,
							"format": "836",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.22053231939164,
						"dataLabels": {
							"enabled": true,
							"format": "713",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.22367846221057,
						"dataLabels": {
							"enabled": true,
							"format": "2111",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.19528178243775,
						"dataLabels": {
							"enabled": true,
							"format": "1767",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.47706422018348,
						"dataLabels": {
							"enabled": true,
							"format": "1659",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.5744866754041,
						"dataLabels": {
							"enabled": true,
							"format": "1501",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.16732197466142,
						"dataLabels": {
							"enabled": true,
							"format": "1217",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.91115311909263,
						"dataLabels": {
							"enabled": true,
							"format": "5898",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.63074984247007,
						"dataLabels": {
							"enabled": true,
							"format": "4928",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.64524259609325,
						"dataLabels": {
							"enabled": true,
							"format": "4675",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.64398235664775,
						"dataLabels": {
							"enabled": true,
							"format": "4421",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.341524889729044,
						"dataLabels": {
							"enabled": true,
							"format": "3767",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.462925851703403,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.912280701754387,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.216494845360821,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.407407407407405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.59192825112108,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -8.060836501901136,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.550041356492972,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.974534769833495,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.916666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.712918660287077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.776321537789432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.29559450497394,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.112054329371819,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.920719520319786,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.088846880907374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.44625296710749,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.133928571428569,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.433155080213902,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.793033250395837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=499"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1315"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2289"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6348"
			}
		],
		"dataTable": {
			"< 30": [
				499,
				342,
				291,
				270,
				223,
				186
			],
			"30–39": [
				1315,
				1209,
				1021,
				960,
				836,
				713
			],
			"40–49": [
				2289,
				2111,
				1767,
				1659,
				1501,
				1217
			],
			"≥ 50": [
				6348,
				5898,
				4928,
				4675,
				4421,
				3767
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 168
// module chunks = 0